import { ContactEntry } from '../type/contact-entry';
import { createContext } from 'react';
import { PageContextValue } from '../../../core/type';
import { Contact } from '../type/contact';

export const ContactPageContext = createContext<PageContextValue<Contact, ContactEntry>>({})
